import { Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import SidebarIcon from '../assets/SidebarComponents/index';

export default function Sidebar({ open, onClose }) {
  const navigate = useNavigate();

  const go = (path) => {
    onClose();
    if (path) navigate(path);
  };

  return (
    <Fragment>
      {/* Backdrop */}
      <div
        className={`fixed inset-0 bg-black bg-opacity-40 transition-opacity z-40 ${open ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`}
        onClick={onClose}
        aria-hidden={!open}
      />

      {/* Sidebar panel */}
      <aside
        className={`fixed top-0 left-0 bottom-0 w-80 max-w-full bg-white shadow-xl transform transition-transform duration-300 ease-in-out z-50 ${open ? 'translate-x-0' : '-translate-x-full'}`}
        role="dialog"
        aria-modal="true"
        aria-hidden={!open}
      >
        <div className="h-full overflow-y-auto">
          <div className="px-4 pt-6 pb-4 flex items-center justify-between border-b">
            <button onClick={onClose} className="text-gray-600 p-2 rounded-md hover:bg-gray-100">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M7.707 14.707a1 1 0 01-1.414-1.414L9.586 10 6.293 6.707a1 1 0 111.414-1.414L11 8.586l3.293-3.293a1 1 0 111.414 1.414L12.414 10l3.293 3.293a1 1 0 01-1.414 1.414L11 11.414l-3.293 3.293z" clipRule="evenodd" />
              </svg>
            </button>
            <h3 className="text-lg font-semibold">Recursos</h3>
            <div style={{ width: 32 }} />
          </div>

          <div className="px-4 py-4">
            {/* Section: Pedidos */}
            <div className="mb-6">
              <h4 className="text-sm font-medium mb-3">Pedidos</h4>
              <div className="space-y-2">
                <button onClick={() => go("/Todos_os_pedidos")} className="w-full text-left px-3 py-3 rounded-lg border hover:bg-gray-50 flex items-center gap-3">
                  <SidebarIcon iconName="Todosospedidos" className="h-5 w-5 flex-shrink-0" />
                  <span className="text-sm">Todos os pedidos</span>
                </button>
                <button onClick={() => go('/Registrar_pedido')} className="w-full text-left px-3 py-3 rounded-lg border hover:bg-gray-50 flex items-center gap-3">
                  <SidebarIcon iconName="Registrarpedido" className="h-5 w-5 flex-shrink-0" />
                  <span className="text-sm">Registrar pedido (PDV)</span>
                </button>
                <button onClick={() => go('/Leitor_codigos')} className="w-full text-left px-3 py-3 rounded-lg border hover:bg-gray-50 flex items-center gap-3">
                  <SidebarIcon iconName="Leitordecodigos" className="h-5 w-5 flex-shrink-0" />
                  <span className="text-sm">Leitor de códigos</span>
                </button>
                <div className="relative">
                  <button onClick={() => go('/Emissao_notas')} className="w-full text-left px-3 py-3 rounded-lg border hover:bg-gray-50 flex items-center gap-3">
                    <SidebarIcon iconName="Emissaodenotas" className="h-5 w-5 flex-shrink-0" />
                    <span className="text-sm">Emissão de notas fiscais</span>
                    <span className="ml-auto inline-block text-xs bg-purple-100 text-purple-600 px-2 py-0.5 rounded-full">NOVO</span>
                  </button>
                </div>
                <button onClick={() => go('/Estatisticas')} className="w-full text-left px-3 py-3 rounded-lg border hover:bg-gray-50 flex items-center gap-3">
                  <SidebarIcon iconName="Estatisticas" className="h-5 w-5 flex-shrink-0" />
                  <span className="text-sm">Estatísticas</span>
                </button>
              </div>
            </div>

            {/* Section: Mercadoria */}
            <div className="mb-6">
              <h4 className="text-sm font-medium mb-3">Mercadoria</h4>
              <div className="space-y-2">
                <button onClick={() => go('/Pedidos')} className="w-full text-left px-3 py-3 rounded-lg border hover:bg-gray-50 text-sm flex items-center gap-3"><SidebarIcon iconName="Pedidos" className="h-5 w-5 flex-shrink-0" />Pedidos</button>
                <button onClick={() => go('/Categorias')} className="w-full text-left px-3 py-3 rounded-lg border hover:bg-gray-50 text-sm flex items-center gap-3"><SidebarIcon iconName="Categorias" className="h-5 w-5 flex-shrink-0" />Categorias</button>
                <button onClick={() => go('/Producao')} className="w-full text-left px-3 py-3 rounded-lg border hover:bg-gray-50 text-sm flex items-center gap-3"> <SidebarIcon iconName="Visordeproducao" className="h-5 w-5 flex-shrink-0" />Visor de produção de pedidos <span className="ml-2 inline-block text-xs bg-purple-100 text-purple-600 px-2 py-0.5 rounded-full">NOVO</span></button>
                <button onClick={() => go('/Produtos')} className="w-full text-left px-3 py-3 rounded-lg border hover:bg-gray-50 text-sm flex items-center gap-3"><SidebarIcon iconName="Produtos" className="h-5 w-5 flex-shrink-0" />Produtos</button>
                <button onClick={() => go('/Registrar_devolucao')} className="w-full text-left px-3 py-3 rounded-lg border hover:bg-gray-50 text-sm flex items-center gap-3"><SidebarIcon iconName="Registrardevolucao" className="h-5 w-5 flex-shrink-0" />Registrar devolução</button>
              </div>
            </div>

            {/* Section: Loja */}
            <div className="mb-6">
              <h4 className="text-sm font-medium mb-3">Loja</h4>
              <div className="space-y-2">
                <button onClick={() => go('/Perfil')} className="w-full text-left px-3 py-3 rounded-lg border hover:bg-gray-50 text-sm flex items-center gap-3"><SidebarIcon iconName="Perfil" className="h-5 w-5 flex-shrink-0" />Perfil</button>
                <button onClick={() => go('/Informacoes_fiscais')} className="w-full text-left px-3 py-3 rounded-lg border hover:bg-gray-50 text-sm flex items-center gap-3"><SidebarIcon iconName="Informacoesfiscais" className="h-5 w-5 flex-shrink-0" />Informações fiscais</button>
                <button onClick={() => go('/Faturamento')} className="w-full text-left px-3 py-3 rounded-lg border hover:bg-gray-50 text-sm flex items-center gap-3"><SidebarIcon iconName="Faturamento" className="h-5 w-5 flex-shrink-0" />Faturamento</button>
                <button onClick={() => go('/Documentos')} className="w-full text-left px-3 py-3 rounded-lg border hover:bg-gray-50 text-sm flex items-center gap-3"><SidebarIcon iconName="Documentos" className="h-5 w-5 flex-shrink-0" />Documentos</button>
                <button onClick={() => go('/Descontos')} className="w-full text-left px-3 py-3 rounded-lg border hover:bg-gray-50 text-sm flex items-center gap-3"><SidebarIcon iconName="Descontos" className="h-5 w-5 flex-shrink-0" />Descontos</button>
                <button onClick={() => go('/Formas_pagamento')} className="w-full text-left px-3 py-3 rounded-lg border hover:bg-gray-50 text-sm flex items-center gap-3"><SidebarIcon iconName="Formasdepagamento" className="h-5 w-5 flex-shrink-0" />Formas de pagamento</button>
                <button onClick={() => go('/Metodos_envio')} className="w-full text-left px-3 py-3 rounded-lg border hover:bg-gray-50 text-sm flex items-center gap-3"><SidebarIcon iconName="Metodosdeenvio" className="h-5 w-5 flex-shrink-0" />Métodos de envio</button>
                <button onClick={() => go('/Horarios')} className="w-full text-left px-3 py-3 rounded-lg border hover:bg-gray-50 text-sm flex items-center gap-3"><SidebarIcon iconName="Horarios" className="h-5 w-5 flex-shrink-0" />Horários de funcionamento</button>
                <button onClick={() => go('/Perguntas')} className="w-full text-left px-3 py-3 rounded-lg border hover:bg-gray-50 text-sm flex items-center gap-3"><SidebarIcon iconName="Perguntas" className="h-5 w-5 flex-shrink-0" />Perguntas e respostas</button>              
              </div>
            </div>

            {/* Geppro Store */}
            <div className="mb-6">
              <h4 className="text-sm font-medium mb-3">Geppro Store</h4>
              <div className="space-y-2">
                <button onClick={() => go('/Gerenciar_totens')} className="w-full text-left px-3 py-3 rounded-lg border hover:bg-gray-50 text-sm flex items-center gap-3"><SidebarIcon iconName="Totens" className="h-5 w-5 flex-shrink-0" />Gerenciar totens</button>
              </div>
            </div>
          </div>
        </div>
      </aside>
    </Fragment>
  );
}
